import React from "react"
import PropTypes from "prop-types"

import {View} from "@instructure/ui-view"
import {Button} from "@instructure/ui-buttons"
import {Flex} from "@instructure/ui-flex";
import {Link} from "@instructure/ui-link";
import {Text} from "@instructure/ui-text";
import {IconQuestionLine} from "@instructure/ui-icons";

import Picker from "emoji-picker-react";


class EmojiPicker extends React.Component {

    static propTypes = {
        selection: PropTypes.string,
        returnUrl: PropTypes.string.isRequired,
        data: PropTypes.string.isRequired
    }


    state = {
        source: "",
        emoji: null,
        contentItems: "",
        message: null,
    }

    constructor(props, context) {
        super(props, context)
        this.formRef = React.createRef()
    }

    makeContentItem = (html) => {
        // Don't return anything if empty
        let item = []
        if (html.length > 0) {
            item.push({
                '@type': 'ContentItem',
                'mediaType': 'text/html',
                'text': html,
                'placementAdvice': {
                    'presentationDocumentTarget': 'embed'
                }
            })
        }
        return {
            '@context': 'http://purl.imsglobal.org/ctx/lti/v1/ContentItem',
            '@graph': item
        }
    }

    toEmpty = (value) => {
        // This is so that we don't put null values into input elements.
        return value !== null && value !== undefined ? value : ''
    }

    onCancelClick = async () => {
        await this.setState({
            contentItems: JSON.stringify(this.makeContentItem(""))
        })
        this.formRef.current.submit()
    }

    onClick = () => {
        this.setState({
            contentItems: JSON.stringify(this.makeContentItem(this.state.emoji)),
            // We don't want to include a message as that results in Canvas displaying an extra screen and delaying
            // inserting the content into the page.
        }, () => this.formRef.current.submit())
    }

    render() {
        const returnUrl = this.props.returnUrl
        const noReturn = !(returnUrl && returnUrl.length > 0)
        const noSelection = !this.state.emoji

        return <View as='div' height='100%'>
            <form action={returnUrl} method='POST' ref={this.formRef}>
                <input type='hidden' name='lti_version' value='LTI-1p0'/>
                <input type='hidden' name='lti_message_type' value='ContentItemSelection'/>
                <input type='hidden' name='data' value={this.toEmpty(this.props.data)}/>
                <input type='hidden' name='content_items' value={this.toEmpty(this.state.contentItems)}/>
                <input type='hidden' name='lti_msg' value={this.toEmpty(this.state.message)}/>
            </form>

            <Flex direction="column" height='100%'>
                <Flex.Item padding='small' align='center'>
                    <Picker onEmojiClick={(event, value) => {
                        if (this.state.emoji === value.emoji) {
                            // Double clicking on the emoji just inserts it.
                            this.onClick()
                        } else {
                            this.setState({emoji: value.emoji})
                        }
                    }} native/>
                </Flex.Item>
                <Flex.Item padding='small' align='start' textAlign='center' >
                    <Text size='large' lineHeight='default' weight='light'>
                        Selected: {this.state.emoji}
                    </Text>
                </Flex.Item>
                <Flex.Item shouldGrow/>
                <Flex.Item padding='small' align='end'>
                    <Flex>
                        <Flex.Item>
                            <Link renderIcon={IconQuestionLine} margin='0 medium' target='_blank'
                                  href='https://wyelearning.com/support/emoji-picker/'>Help</Link>
                        </Flex.Item>
                        <Flex.Item>
                            <Button onClick={this.onCancelClick} margin='xx-small'
                                    interaction={noReturn ? 'disabled' : 'enabled'}>Cancel</Button>
                            <Button color='primary' onClick={this.onClick} margin='xx-small'
                            interaction={(noReturn || noSelection)?'disabled':'enabled'}>Insert</Button>
                        </Flex.Item>
                    </Flex>
                </Flex.Item>
            </Flex>

        </View>
    }


}

export default EmojiPicker